import useUniqueTableName from '../../../hooks/useUniqueTableName';
import { TAB_IDS } from '../hooks';
import useBaseTableProps from '../../../hooks/useBaseTableProps';
import {
  useTableFilterSortData,
  useTableFilterSortSearchManager,
  useTableManageColumns,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { PROPERTY_PATH_MAP } from './constants';
import useRows from './hooks.useRows';
import useHeaders from './hooks.useHeaders';

const useRegularAssistancePayments = ({
  regularAssistancePayments = [],
  hasVariance = false,
  isReadOnly = false,
  onSaveApprovedAmount,
  propertyId,
  canManage,
}) => {
  const name = useUniqueTableName(TAB_IDS.REGULAR_ASSISTANCE_PAYMENTS);
  const baseTableProps = useBaseTableProps();

  const results = regularAssistancePayments;

  const headers = useHeaders({ results });

  const {
    filterState,
    filterTypeState,
    dateState,
    order,
    orderBy,
    handleSortChange,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleDateSubmit,
    searchState,
  } = useTableFilterSortSearchManager({
    name,
    headers,
    initialOrderBy: '',
    initialOrder: 'ASC',
  });

  const sortedAndFilteredResults = useTableFilterSortData({
    results,
    order,
    orderBy,
    filterState,
    filterTypeState,
    searchState,
    dateState,
    PROPERTY_PATH_MAP,
  });

  const rows = useRows({
    results: sortedAndFilteredResults,
    hasVariance,
    isReadOnly,
    onSaveApprovedAmount,
    propertyId,
    canManage,
  });

  const {
    allColumnsHidden,
    columnOptions,
    filteredHeaders,
    selectedColumns,
    handleColumnChange,
  } = useTableManageColumns({
    name,
    headers,
    firstRow: rows?.[0],
  });

  return {
    allColumnsHidden,
    baseTableProps,
    columnOptions,
    count: rows?.length ?? 0,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    rowsLoading: false,
    name,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    totalCount: results.length,
  };
};

export default useRegularAssistancePayments;
